/**
 * Script custom for theme
 *
 * TABLE OF CONTENT
 *
 */

(function ($) {
	"use strict";

	$(document).ready(function () {
		thim_startertheme.ready();
	});

	$(window).load(function () {
		thim_startertheme.load();
	});

	var thim_startertheme = {

		/**
		 * Call functions when document ready
		 */
		ready: function () {
            this.header_menu();
            this.header_menu_mobile();
            this.custom_menu();
            this.feature_preloading();
            this.slide_slick_col_post();
            this.sticky_sidebar();
            this.back_to_top();
            this.popup_form();
            this.magnific_popup_video();
            this.popup_gallery();
            this.left_right();
            this.load_more_gallery();
            this.load_more_courses();
            this.load_more_teacher();
            this.custom_select_box();
            this.load_more_events();
		},


		/**
		 * Call functions when window load.
		 */
		load: function () {

		},

        /**
         * feature: Preloading
         */
        feature_preloading: function() {
            var $preload = $('#thim-preloading');
            if ($preload.length > 0) {
                $preload.fadeOut(1000, function() {
                    $preload.remove();
                });
            }
        },

        /**
         * custom_menu
         */
        custom_menu: function() {
            if($(window).outerWidth() <= 992) {
                $('.site-header.layout-1 .main-navigation').addClass('d-block');
                divMenu();
                $('.site-header.layout-1 .main-navigation').removeClass('d-block');
            }
            else {
                divMenu();
            }

            function divMenu() {
                var $header = $('.site-header.layout-1');
                var $headerWraper = $header.find('.wrap-content-header');
                var $mainNavigation = $headerWraper.find('.main-navigation');
                var itemMenu = $mainNavigation.find('.menu-lists > li');
                var menuRightSize = 0;
                var totalSize = 0;
                for(var i=0; i<itemMenu.length; i++) {
                    totalSize += $(itemMenu[i]).outerWidth();
                }
                totalSize += menuRightSize;
                $mainNavigation.addClass('right-side');
                $headerWraper.prepend('<nav class="main-navigation left-side"><ul class="menu-lists"></ul></nav>');
                var currentSize = 0;
                for(var i=0; i<itemMenu.length; i++) {
                    if((currentSize + $(itemMenu[i]).outerWidth() <= totalSize/2)
                        || (totalSize - menuRightSize < $headerWraper.outerWidth()/100*40)) {
                        currentSize += $(itemMenu[i]).outerWidth();
                        $('.main-navigation.left-side .menu-lists').append($(itemMenu[i]).clone());
                        $(itemMenu[i]).remove();
                    }
                    else {
                        if((totalSize/2 - currentSize) > $(itemMenu[i]).outerWidth() / 2) {
                            $('.main-navigation.left-side .menu-lists').append($(itemMenu[i]).clone());
                            $(itemMenu[i]).remove();
                            break;
                        }
                    }
                }
                $($header).find('.header-inner').removeClass('invisible');
            }
        },

        /**
         * Header menu sticky, scroll, v.v.
         */
        header_menu: function() {
            var off_Top = ($('#wrapper-container').length > 0) ? $('#wrapper-container').offset().top : 0;
            var dentalTop = off_Top;
            if($(window).outerWidth() <= 600) {
                dentalTop = 0;
            }
            var $topbar = $('#toolbar');
            var $header = $('.sticky-header');
            var $elementToStick = $header.find('.element-to-stick');
            var latestScroll = 0;

            if ($('#toolbar').length) {
                $('.header-overlay').css({
                    top: $('#toolbar').outerHeight() + off_Top + 'px',
                });
            }
            else {
                $('.header-overlay').css({
                    top: off_Top + 'px',
                });
            }

            $elementToStick.css('top', dentalTop + 'px');

            var startFixed = $elementToStick.offset().top - dentalTop;

            $(window).scroll(function() {
                var current = $(this).scrollTop();

                if (current > startFixed) {
                    $header.css('height', $header.outerHeight() + 'px');

                    $header.addClass('fixed');
                } else {
                    $header.removeClass('fixed');
                    $header.css('height', 'auto');
                }

                if (current > latestScroll && current > $elementToStick.outerHeight() + startFixed) {
                    if (!$header.hasClass('menu-hidden')) {
                        $header.addClass('menu-hidden');
                        $elementToStick.css({
                            top: - $elementToStick.outerHeight(),
                        });
                    }
                } else {
                    if ($header.hasClass('menu-hidden')) {
                        $header.removeClass('menu-hidden');
                        $elementToStick.css({
                            top: dentalTop,
                        });
                    }
                }

                latestScroll = current;
            });

            /*---------------------------------------------*/
            $(window).on('load',function(){
                responSubMenu();
            });

            $(window).on('resize',function(){
                responSubMenu();
            });

            var responSubMenu = function(){
                $('.main-navigation .menu-lists > li').each(function(){
                    var obj = $(this);
                    var posRight = 0;
                    var posRightSub = 0;
                    var deepestSubMenu = obj.children('.sub-menu').children().children('.sub-menu');
                    var numOfSubMenu = 1;

                    while(deepestSubMenu.find('.sub-menu').length > 0) {
                        numOfSubMenu++;
                        deepestSubMenu = deepestSubMenu.find('.sub-menu');
                    }

                    if(obj.children('.sub-menu').length > 0) {
                        posRight = obj.offset().left + obj.children('.sub-menu').outerWidth();

                        if(deepestSubMenu.length > 0) {
                            posRightSub = posRight + deepestSubMenu.outerWidth() * numOfSubMenu;
                        }
                    }

                    if(posRight >= $(window).width()) {
                        var move = posRight - $(window).width();
                        obj.children('.sub-menu').css('left', '-' + move + 'px');
                    }
                    else {
                        obj.children('.sub-menu').css('left', '0');
                    }

                    if(posRightSub >= $(window).width()) {
                        obj.children('.sub-menu').find('.sub-menu').css({'left':'auto','right':'calc(100%)'});
                    }
                    else {
                        obj.children('.sub-menu').find('.sub-menu').css({'right':'auto','left':'calc(100%)'});
                    }
                });
            };
        },

        /**
         * Mobile menu
         */
        header_menu_mobile: function() {

            $(document).on('click', '.menu-mobile-effect', function(e) {
                e.stopPropagation();
                $('.responsive #wrapper-container').
                toggleClass('mobile-menu-open');
            });

            $(document).on('click', '.mobile-menu-open', function() { console.log('hello');
                $('.responsive #wrapper-container.mobile-menu-open').
                removeClass('mobile-menu-open');
            });

            $('.responsive .mobile-menu-container .menu li.menu-item-has-children >a').after('<span class="icon-toggle"><i class="fa fa-angle-down"></i></span>');
            $('.mobile-menu-container .widget_nav_menu .menu-useful-links-container .menu>li.menu-item-has-children >a').after('<span class="icon-toggle"><i class="fa fa-angle-down"></i></span>');

            $('.responsive .mobile-menu-container .menu li.menu-item-has-children .icon-toggle, .mobile-menu-container .widget_nav_menu .menu-useful-links-container .menu>li.menu-item-has-children .icon-toggle').
            on('click', function() {
                if ($(this).next('ul.sub-menu').is(':hidden')) {
                    $(this).next('ul.sub-menu').slideDown(200, 'linear');
                    $(this).html('<i class="fa fa-angle-up"></i>');
                } else {
                    $(this).next('ul.sub-menu').slideUp(200, 'linear');
                    $(this).html('<i class="fa fa-angle-down"></i>');
                }
            });

            $('.mobile-menu-container').on('click', function(e) {
                e.stopPropagation();
            })
        },

        /**
         * Slide slick col.
         */
        slide_slick_col_post: function() {
            $('.js-call-slick-post').each(function(){
                var data =  [
                    ['responsive', 'array'],
                    ['customdot', 'bool'],
                    ['numofshow', 'number'],
                    ['numofscroll', 'number'],
                    ['fade', 'bool'],
                    ['loopslide', 'bool'],
                    ['autoscroll', 'bool'],
                    ['speedauto', 'number'],
                    ['verticalslide', 'bool'],
                    ['verticalswipe', 'bool'],
                    ['rtl', 'bool'],
                    ['navfor', 'string'],
                    ['animate', 'bool'],
                    ['middlearrow', 'string']
                ]

                var parameter = {
                    responsive: [[1, 1], [1, 1], [1, 1], [1, 1], [1, 1]],
                    customdot: false,
                    numofshow: 1,
                    numofscroll: 1,
                    fade: false,
                    loopslide: false,
                    autoscroll: false,
                    speedauto: 5000,
                    verticalslide: false,
                    verticalswipe: false,
                    rtl: false,
                    navfor: '',
                    animate: false,
                    middlearrow: null
                }

                var showDot = false;
                var showArrow = false;
                var wrapSlick = $(this);
                var slideSlick = $(this).find('.slide-slick');
                var itemSlick = $(slideSlick).find('.item-slick');
                var layerSlick = $(slideSlick).find('[data-appear]');
                var actionSlick = [];

                // Check show dot, arrows
                if($(wrapSlick).find('.wrap-dot-slick').length > 0) {
                    showDot = true;
                }

                if($(wrapSlick).find('.wrap-arrow-slick').length > 0) {
                    showArrow = true;
                }

                // Get data
                for(var i=0; i<data.length; i++) {
                    var value = $(this).data(data[i][0]);

                    if (value != null) {
                        if(data[i][1] === 'bool') {
                            if(value === '1' || value === 1) {
                                parameter[data[i][0]] = true;
                            } else {
                                parameter[data[i][0]] = false;
                            }
                        }
                        else if(data[i][1] === 'number') {
                            parameter[data[i][0]] = Number(value);
                        }
                        else if(data[i][1] === 'string') {
                            parameter[data[i][0]] = value;
                        }
                        else if(data[i][1] === 'array') {
                            var strArray = value.match(/(\d+)/g);
                            parameter[data[i][0]] = [
                                [Number(strArray[0]), Number(strArray[1])],
                                [Number(strArray[2]), Number(strArray[3])],
                                [Number(strArray[4]), Number(strArray[5])],
                                [Number(strArray[6]), Number(strArray[7])],
                                [Number(strArray[8]), Number(strArray[9])]
                            ]
                        }
                    }
                }

                // Call slick
                if(parameter.animate) {
                    $(layerSlick).addClass('animated').css('visibility', 'hidden');

                    $(slideSlick).on('init', function(){
                        showLayer(0);
                    });
                }

                $(slideSlick).slick({
                    asNavFor: parameter.navfor,
                    rtl: parameter.rtl,
                    vertical: parameter.verticalslide,
                    verticalSwiping: parameter.verticalswipe,
                    pauseOnFocus: false,
                    pauseOnHover: true,
                    slidesToShow: parameter.numofshow,
                    slidesToScroll: parameter.numofscroll,
                    fade: parameter.fade,
                    infinite: parameter.loopslide,
                    autoplay: parameter.autoscroll,
                    autoplaySpeed: parameter.speedauto,
                    arrows: showArrow,
                    appendArrows: $(wrapSlick).find('.wrap-arrow-slick'),
                    prevArrow: $(wrapSlick).find('.prev-slick'),
                    nextArrow: $(wrapSlick).find('.next-slick'),
                    dots: showDot,
                    appendDots: $(wrapSlick).find('.wrap-dot-slick'),
                    dotsClass:'dots-slick',
                    customPaging: function(slick, index) {
                        var portrait = $(slick.$slides[index]).data('thumb');

                        if(parameter.customdot) return '<img src=" ' + portrait + ' "/>';

                        return '<span></span>'
                    },
                    responsive: [
                        {
                            breakpoint: 1368,
                            settings: {
                                slidesToShow: parameter.responsive[0][0],
                                slidesToScroll: parameter.responsive[0][1]
                            }
                        },
                        {
                            breakpoint: 1199,
                            settings: {
                                slidesToShow: parameter.responsive[1][0],
                                slidesToScroll: parameter.responsive[1][1]
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: parameter.responsive[2][0],
                                slidesToScroll: parameter.responsive[2][1]
                            }
                        },
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: parameter.responsive[3][0],
                                slidesToScroll: parameter.responsive[3][1]
                            }
                        },
                        {
                            breakpoint: 575,
                            settings: {
                                slidesToShow: parameter.responsive[4][0],
                                slidesToScroll: parameter.responsive[4][1]
                            }
                        }
                    ]
                })
                    .on('setPosition', function(event, slick){
                        // Equal height
                        if($(this).parent().data('equalheight') === '1' || $(this).parent().data('equalheight') === 1) {
                            var maxHeight = 0;
                            var $items = $(this).find('.item-slick');

                            $items.each(function(){
                                if($(this).outerHeight() > maxHeight) {
                                    maxHeight = $(this).outerHeight();
                                }
                            })

                            $items.css('min-height', maxHeight);
                        }

                        // Middle Arrow
                        if(parameter.middlearrow != null) {
                            var $wrapArrows = $(wrapSlick).find('.wrap-arrow-slick');
                            var middleOf = $(wrapSlick).find(parameter.middlearrow).outerHeight();

                            $wrapArrows.css('height', middleOf + 'px');
                        }
                    });

                // Animate
                if(parameter.animate) {
                    $(slideSlick).on('afterChange', function(event, slick, currentSlide){
                        showLayer(currentSlide);
                    });
                }

                function showLayer(currentSlide) {
                    var layerCurrentItem = $(itemSlick[currentSlide]).find('[data-appear]');

                    for(var i=0; i<actionSlick.length; i++) {
                        clearTimeout(actionSlick[i]);
                    }

                    $(layerSlick).each(function(){
                        $(this).removeClass($(this).data('appear')).css('visibility', 'hidden');
                    })


                    for(var i=0; i<layerCurrentItem.length; i++) {
                        actionSlick[i] = setTimeout(function(index) {
                            $(layerCurrentItem[index]).addClass($(layerCurrentItem[index]).data('appear')).css('visibility', 'visible');
                        },$(layerCurrentItem[i]).data('delay'),i);
                    }
                };
            });
        },

        /**
         * sticky_sidebar
         */
        sticky_sidebar: function() {
            try {
                var offsetTop = 10;
                var spacingTop = 20;

                if($('#wpadminbar').length) {
                    offsetTop += $('#wpadminbar').outerHeight();
                    spacingTop += $('#wpadminbar').outerHeight();
                }

                if($('.sticky-header .element-to-stick').length) {
                    offsetTop += $('.sticky-header .element-to-stick').outerHeight();
                }

                $('.sticky-sidebar').each(function () {
                    if ($(this).length > 0) {
                        if ( $().theiaStickySidebar ) {
                            $(this).theiaStickySidebar({
                                'typeSticky'            : 1,
                                'spacingTopDefault'     : spacingTop,
                                'containerSelector'     : '',
                                'additionalMarginTop'   : offsetTop,
                                'additionalMarginBottom': 10,
                                'updateSidebarHeight'   : false,
                                'minWidth'              : 992,
                                'sidebarBehavior'       : 'modern',
                            });
                        }
                    }
                });

            } catch(er) {console.log(er);}
        },

        /**
         * Back to top
         */
        back_to_top: function() {
            var $element = $('#back-to-top');
            $(window).scroll(function() {
                if ($(this).scrollTop() > 100) {
                    $element.addClass('scrolldown').removeClass('scrollup');
                } else {
                    $element.addClass('scrollup').removeClass('scrolldown');
                }
            });

            $element.on('click', function() {
                $('html,body').animate({scrollTop: '0px'}, 800);
                return false;
            });
        },

        /**
         * Magnic popup
         */
        popup_form: function () {
            $('.js-popup-form').magnificPopup({
                type: 'inline',
                preloader: false,

                callbacks: {
                    beforeOpen: function() {
                        this.st.mainClass = this.st.el.attr('data-effect');
                    }
                }
            });
        },

        /**
         * Magnific-Popup-Video
         */
        magnific_popup_video: function() {
            try {
                $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
                    disableOn: 700,
                    type: 'iframe',
                    mainClass: 'mfp-fade',
                    removalDelay: 160,
                    preloader: false,

                    fixedContentPos: false
                });
            } catch(er) {console.log(er);}
        },

        /**
         * popup_gallery
         */
        popup_gallery: function() {
            try {
                $('.gallery-popup').each(function() {
                    $(this).find('.js-show-gallery').magnificPopup({
                        type: 'image',
                        fixedContentPos : false,
                        gallery: {
                            enabled:true
                        },
                        mainClass: 'mfp-fade'
                    });
                });
            } catch(er) {console.log(er);}
        },

        /**
         * padding left+right
         */
        left_right: function () {
            try {
                var setPaddingLeft = $('.padding-left-base-container > .vc_column-inner');
                var setPaddingRight = $('.padding-right-base-container > .vc_column-inner');
                if($(window).outerWidth() > 1145) {
                    $(setPaddingLeft).css('padding-left', ($(window).outerWidth() - $('.container').outerWidth()) / 2 + 'px');
                    $(setPaddingRight).css('padding-right', ($(window).outerWidth() - $('.container').outerWidth()) / 2 + 'px');
                }
                $(window).on('resize', function() {
                    if($(window).outerWidth() > 1145) {
                        $(setPaddingLeft).css('padding-left', ($(window).outerWidth() - $('.container').outerWidth()) / 2 + 'px');
                        $(setPaddingRight).css('padding-right', ($(window).outerWidth() - $('.container').outerWidth()) / 2 + 'px');
                    }
                })
            } catch(er) {console.log(er);}
        },

        /**
         * Load more gallery
         */
        load_more_gallery: function () {
            try {
                var thisJS = this;
                $('.gallery-list .load-more-gallery:not("loading")').on('click', function() {
                    var list_gallery = $('.gallery-list .gallery-popup'),
                        item_click = $(this),
                        paged = $(this).attr('data-paged');
                    item_click.addClass('loading');
                    item_click.append('<i class="fa fa-spinner fa-spin"></i>');
                    $.ajax({
                        type: 'POST',
                        data: 'action=thim_load_more_gallery&paged=' + paged,
                        url: ajaxurl,
                        success: function (res) {
                            if( parseInt(paged) >= parseInt(item_click.attr('data-maxpage')) ) {
                                item_click.hide();
                            }
                            paged = parseInt(paged)+1;
                            item_click.find('i').remove();
                            item_click.attr('data-paged',paged).removeClass('loading');
                            list_gallery.append(res.data);
                            thisJS.popup_gallery();
                        },
                    });
                    return false;
                });
            } catch(er) {console.log(er);}
        },

        /**
         * Load more courses
         */
        load_more_courses: function () {
            try {
                $('.lp-archive-courses .load-more-courses:not("loading")').on('click', function() {
                    var list_gallery = $('.lp-archive-courses .learn-press-courses'),
                        item_click = $(this),
                        paged = $(this).attr('data-paged');
                    item_click.addClass('loading');
                    item_click.append('<i class="fa fa-spinner fa-spin"></i>');
                    $.ajax({
                        type: 'POST',
                        data: 'action=thim_load_more_courses&paged=' + paged,
                        url: ajaxurl,
                        success: function (res) {
                            if( parseInt(paged) >= parseInt(item_click.attr('data-maxpage')) ) {
                                item_click.hide();
                            }
                            paged = parseInt(paged)+1;
                            item_click.find('i').remove();
                            item_click.attr('data-paged',paged).removeClass('loading');
                            list_gallery.append(res.data);
                        },
                    });
                    return false;
                });
            } catch(er) {console.log(er);}
        },

        /*
       * load_more_teacher
       *
       * */
        load_more_teacher: function() {
            try {
                $('.teachers-list--teachers-page .load-more-teacher:not("loading")').on('click', function () {
                    var list_gallery = $('.teachers-list--teachers-page .teacher-group'),
                        item_click = $(this),
                        paged = $(this).attr('data-paged');
                    item_click.addClass('loading');
                    item_click.append('<i class="fa fa-spinner fa-spin"></i>');
                    $.ajax({
                        type: 'POST',
                        data: 'action=thim_load_more_teacher&paged=' + paged,
                        url: ajaxurl,
                        success: function (res) {
                            if (parseInt(paged) >= parseInt(item_click.attr('data-maxpage'))) {
                                item_click.hide();
                            }
                            paged = parseInt(paged) + 1;
                            item_click.find('i').remove();
                            item_click.attr('data-paged', paged).removeClass('loading');
                            list_gallery.append(res.data);
                        },
                    });
                    return false;
                });
            } catch (er) {
                console.log(er);
            }
        },


        /*
        * load_more_events
        * */
        load_more_events:function() {
            try {
                $('.event-list--events-page .load-more-events:not("loading")').on('click', function () {
                    var list_gallery = $('.event-list--events-page .events-group'),
                        item_click = $(this),
                        paged = $(this).attr('data-paged');
                        item_click.addClass('loading');
                        item_click.append('<i class="fa fa-spinner fa-spin"></i>');
                    $.ajax({
                        type: 'POST',
                        data: 'action=thim_load_more_events&paged=' + paged,
                        url: ajaxurl,
                        success: function (res) {
                            if (parseInt(paged) >= parseInt(item_click.attr('data-maxpage'))) {
                                item_click.hide();
                            }
                            paged = parseInt(paged) + 1;
                            item_click.find('i').remove();
                            item_click.attr('data-paged', paged).removeClass('loading');
                            list_gallery.append(res.data);
                        },
                    });
                    return false;
                });
            } catch (er) {
                console.log(er);
            }
        },

        /**
         * Custom select
         */
        custom_select_box: function () {
            try {
                $('select').each(function() {
                    if(!$(this).parent().hasClass('wrap-select2')) {
                        $(this).parent().addClass('wrap-select2');
                    }
                });

                $(".wrap-select2").each(function(){
                    $(this).append('<span class="dropDownSelect2"></span>');

                    var select = $(this).children('select');
                    var style = $(this).data('style');
                    var dropdown = $(this).children('.dropDownSelect2');

                    $(select).select2({
                        minimumResultsForSearch: 20,
                        dropdownParent: dropdown,
                        theme: style,
                    });
                });

            } catch(er) {console.log(er);}
        },
    };

})(jQuery);